<template>
  <div class="py-7 container-fluid">
    <div class="card">
      <div class="card-header pb-6">
        <div class="mb-3">
          <h6 v-if="events.length === 0">Events not found</h6>
          <h6 v-else>Events</h6>
        </div>
      </div>
      <div class="card-body px-5 pt-5 pb-2" v-if="events.length !== 0">
        <div class="mb-3">
          <button class="btn btn-primary btn-sm" @click="cleanAllEvents">
            Clean all
          </button>
        </div>
        <div class="table-responsive p-0">
          <table class="table align-items-center justify-content-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                >
                  Date
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                >
                  Namespace
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                >
                  Stack
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                >
                  Action
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                >
                  Message
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="event in events" :key="event.id">
                <td>
                  <p class="text-xs font-weight-bold mb-0">
                    {{ event.date }}
                  </p>
                </td>
                <td v-if="event.stack">
                  <p class="text-xs font-weight-bold mb-0">
                    {{ event.stack.namespace.name }}
                  </p>
                </td>
                <td v-else>
                  <p class="text-xs font-weight-bold mb-0">-</p>
                </td>
                <td v-if="event.stack">
                  <p class="text-xs font-weight-bold mb-0">
                    {{ event.stack.name }}
                  </p>
                </td>
                <td v-else>
                  <p class="text-xs font-weight-bold mb-0">-</p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">
                    {{ event.action }}
                  </p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">
                    {{ event.message }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <nav aria-label="Page navigation">
            <ul class="pagination justify-content-center">
              <!-- Botón anterior -->
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <button class="page-link" @click="changePage(currentPage - 1)">
                  <i class="bi bi-chevron-left"></i>
                </button>
              </li>

              <!-- Primer página -->
              <li
                class="page-item"
                :class="{ active: currentPage === 1 }"
                v-if="totalPages > 0"
              >
                <button class="page-link" @click="changePage(1)">1</button>
              </li>

              <!-- Puntos suspensivos izquierda -->
              <li class="page-item" v-if="showLeftDots">
                <button class="page-link" disabled>…</button>
              </li>

              <!-- Páginas intermedias -->
              <li
                class="page-item"
                v-for="page in visiblePages"
                :key="page"
                v-if="page !== 1 && page !== totalPages"
                :class="{ active: page === currentPage }"
              >
                <button class="page-link" @click="changePage(page)">{{ page }}</button>
              </li>

              <!-- Puntos suspensivos derecha -->
              <li class="page-item" v-if="showRightDots">
                <button class="page-link" disabled>…</button>
              </li>

              <!-- Última página -->
              <li
                class="page-item"
                :class="{ active: currentPage === totalPages }"
                v-if="totalPages > 1"
              >
                <button class="page-link" @click="changePage(totalPages)">
                  {{ totalPages }}
                </button>
              </li>

              <!-- Botón siguiente -->
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <button class="page-link" @click="changePage(currentPage + 1)">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  components: {},
  data() {
    return {
      events: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  computed: {
    totalPages() {
    return Math.ceil(this.total / this.pageSize);
  },
  visiblePages() {
    const total = this.totalPages;
    const current = this.currentPage;
    const delta = 2;
    const pages = [];

    for (let i = current - delta; i <= current + delta; i++) {
      if (i > 1 && i < total) {
        pages.push(i);
      }
    }

    return pages;
  },
  showLeftDots() {
    return this.currentPage - 2 > 2;
  },
  showRightDots() {
    return this.currentPage + 2 < this.totalPages - 1;
  },
  },
  mounted() {
    this.loadEvents();
  },
  methods: {
    loadEvents() {
      this.$api
        .get(
          `/v1/event/system?page=${this.currentPage}&pagesize=${this.pageSize}`
        )
        .then((response) => {
          this.events = response.data.events;
          this.total = response.data.total;
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            // Redirigir a la página de Forbidden
            this.$router.push("/error/403");
          } else {
            console.error("Error fetching events:", error);
          }
        });
    },
    async cleanAllEvents() {
      try {
        const response = await this.$api.delete(`/v1/event/system`);
        if (response.status >= 200 && response.status < 300) {
          toast.success("Delete all system events sucessfull");
          this.loadEvents();
        }
      } catch (error) {
        toast.error("event delete error");
      }
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.loadEvents();
    },
  },
};
</script>
